import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtractTasksMode } from '../../../ts/services/CreateExtractTasksAction';
import { CreateExtractRefresh } from '../AppActionTypes';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { ServiceLocator } from '../../ServiceLocator';
import { ContentActionNotification } from '../../../ts/services/ContentActionNotification';
import { IError } from '../../../ts/ServerApi/types/IError';
import { Messages } from '../../../codegen/Localize';
import { Recurrence } from '@tableau/self-service-schedules';
import { SetExtractTasksSelfServiceScheduleRequest } from '../../../ts/ServerApi/requests/SetExtractTasksSelfServiceScheduleRequest';
import { SelfServiceSchedule } from '../../../ts/ServerApi/types/SelfServiceSchedule';
import { ServerService } from '../../../ts/services/ServerService';

export interface CreateExtractRefreshAction extends Action {
  selectedContent: IContentInfo[];
  mode: CreateExtractTasksMode;
}

export namespace CreateExtractRefreshAction {
  export function sendCreateExtractRequest(recurrence: Recurrence, taskType: string, scheduleName: string, ids: number[]): Promise<IResult> {
    const request = new SetExtractTasksSelfServiceScheduleRequest({
      schedule: SelfServiceSchedule.fromRecurrence(recurrence, 'Extract'),
      type: taskType,
      scheduleName: scheduleName.substring(0, 255),
      ids,
    });
    const server = ServiceLocator.get<ServerService>('ServerService');
    return new Promise<IResult>((resolve, reject) => {
      server.sendRequest(request).then(result => {
        CreateExtractRefreshAction.notifyResult(result, false);
        resolve(result);
      }).catch(err => {
        CreateExtractRefreshAction.notifyResult();
        reject(err);
      });
    });
  }

  function errorCodeToMessage(error: IError): string {
    switch (error.code) {
      default:
        return Messages.refreshSelfServiceScheduleUnexpectedError({ ERROR_CODE: String(error.code) });
    }
  }

  export function notifyResult(result?: IResult, isNew?: boolean) {
    const notificationService = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');
    if (result && result.errors && result.errors.length) {
      const errorMessage = errorCodeToMessage(result.errors[0]);
      notificationService.notifyFailure(errorMessage);
    } else {
      const toastContent = isNew
        ? Messages.refreshSelfServiceScheduleCreateSuccess()
        : Messages.refreshSelfServiceScheduleChangeSuccess();
      notificationService.notifySuccess(toastContent);
    }
  }
}

export function createExtractRefresh(
  selectedContent: IContentInfo[],
  mode: CreateExtractTasksMode
): CreateExtractRefreshAction {
  return {
    type: CreateExtractRefresh,
    selectedContent,
    mode,
  };
}
